import firebase from "firebase";
import axios from "axios";
import {storage} from "../../firebase";

//helper function to create a quiz entry for newly incoming students who have never visited the page before
export function CreateQuizEntry(classLevel) {
    let promise = new Promise((resolve, reject)=> {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {

                //student entries look like this
                let studentEntry = {email: user.email, assignmentNum: [], assignmentCompletion: [], attempts: [], hint: [], date: []};
                let email = user.email;
                let studentData;
                let found = false;
                let assignmentNames = [];

                //fetch the quiz assignments to create an array
                async function fetchData() {
                    await firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/quizAssignments').listAll()
                        .then((data) => {
                            for (let i = 0; i < data.items.length; i++)
                                assignmentNames.push("assignment" + (i + 1) + ".json")
                        }).catch(e => console.log(e));


                }

                const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/quizData.json');
                studentFile.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        studentData = res.data;
                        for (let i = 0; i < studentData.length; i++) {
                            if (email === studentData[i].email) {
                                found = true;
                                break;
                            }
                        }

                        //If no email is found in the quiz student data, Create an entry for student
                        if (!found) {
                            fetchData().then(async ()=>{
                                for (let i = 0; i < assignmentNames.length; i++) {
                                    const quizAssignment = firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/quizAssignments/' + assignmentNames[i]);
                                    await quizAssignment.getDownloadURL()
                                        .then(url => axios.get(url))
                                        .then(res => {
                                            let questionCount = [];

                                            //Creating the arrays
                                            for(let w = 0; w < res.data.length; w++){
                                                questionCount.push(0);
                                            }
                                            studentEntry.assignmentNum.push(i);
                                            studentEntry.assignmentCompletion.push(questionCount);
                                            studentEntry.attempts.push(questionCount);
                                            studentEntry.hint.push(questionCount);
                                            studentEntry.date.push('')
                                        })
                                }
                            })
                                .then(()=>{

                                    //then push the data onto the quizdata and upload
                                    studentData.push(studentEntry)
                                    const JSONobj = JSON.stringify(studentData);
                                    const blobObj = new Blob([JSONobj], {type: "application/json"});
                                    const uploadTask = storage.ref('students/10' + classLevel + '/quizData.json').put(blobObj);
                                    uploadTask.on(
                                        "state_changed",
                                        () => {
                                        },
                                        error => {
                                            console.log(error)
                                        },
                                        () => {
                                            storage
                                                .ref("students/10" + classLevel)
                                                .child('quizData.json')
                                                .getDownloadURL()
                                                .then(url => {
                                                        console.log(url);
                                                    }
                                                )
                                                .catch(e => console.log(e));
                                        }
                                    )
                                    resolve(found);
                                })

                            //if student is found, return to quiz page
                        } else {
                            resolve(found);
                            return;
                        }

                    });


            }
        })
    })
    return promise;
}
